import { render, staticRenderFns } from "./modalGestionarFaqs.vue?vue&type=template&id=41ef41f0"
import script from "./modalGestionarFaqs.vue?vue&type=script&lang=js"
export * from "./modalGestionarFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports